var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-bar"},[_c('div',{staticClass:"col-xs-10 col-sm-10 col-md-11 col-lg-11 float-Right"},[_c('div',{staticClass:"row row-Style"},[_c('div',{staticClass:"col-xs-11 col-sm-11 col-md-11 col-lg-11 width admin-Panel-Padding font-size-2vw admin-Panel-BG text-align-center"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec9e60e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterBar.vue
// module id = null
// module chunks = 